import { getCustomers } from '../customers.selectors';
import { MANDATE_TYPE_KEY, MandateTypeState } from '../../reducers/mandate-type.reducer';
import { FormDataState } from '../../reducers/form-data.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../../index';
import {
    PLAUSIBILITAET_KEY, PlausibilitaetState,
    selectAllPlausibilitaeten,
    selectPlausibilitaetenFetched,
} from '../../reducers/mdqx/plausibilitaet.reducer';
import {
    CONTRACT2DIAGNOSESICHERHEIT_KEY,
    Contract2DiagnosesicherheitState,
    selectAllContract2Diagnosesicherheiten, selectContract2DiagnosesicherheitenFetched,
} from '../../reducers/mdqx/contract2diagnosesicherheit.reducer';
import { DOCTOR_KEY, DoctorState, selectAllDoctors, selectDoctorsFetched } from '../../reducers/mdqx/doctor/doctor.reducer';
import {
    selectAllSpezifikationen, selectSpezifikationenFetched,
    SPEZIFIKATION_KEY,
    SpezifikationState,
} from '../../reducers/mdqx/spezifikation.reducer';
import {
    CONTRACT_OPTIONS_KEY,
    ContractOptionsState,
    selectAllContractOptions, selectContractOptionsFetched,
} from '../../reducers/mdqx/contract-options.reducer';
import {
    PRACTICE_TYPE_KEY,
    PracticeTypeState,
    selectAllPracticeTypes, selectPracticeTypesFetched,
} from '../../reducers/mdqx/practice-type.reducer';
import {
    CONTRACTGROUPTYPE_KEY,
    ContractGroupTypeState, selectAllContractGroupType,
    selectContractGroupTypeFetched,
} from '../../reducers/mdqx/contract-group-type.reducer';
import {
    selectAllSpezifikationsArten,
    selectSpezifikationsArtenFetched,
    SPEZIFIKATIONSART_KEY, SpezifikationsArtState,
} from '../../reducers/mdqx/spezifikations-art.reducer';
import {
    CONTRACT2FACHBEREICH_KEY, Contract2FachbereichState,
    selectAllContract2Fachbereiche, selectContract2FachbereicheFetched,
} from '../../reducers/mdqx/contract2fachbereich.reducer';
import {
    CONTRACT_KEY,
    ContractState,
    selectAllContracts,
    selectContractsFetched,
} from '../../reducers/mdqx/contract.reducer';
import {
    CONTRACT2PLAUSIBILITAET_KEY, Contract2PlausibilitaetState,
    selectAllContract2Plausibilitaeten,
    selectContract2PlausibilitaetenFetched,
} from '../../reducers/mdqx/contract2plausibilitaet.reducer';
import {
    CONTRACT_PARTNER_KEY,
    ContractPartnerState,
    selectAllContractPartners,
    selectContractPartnersFetched,
} from '../../reducers/mdqx/contract-partner.reducer';
import {
    CONTRACTSTATUS_KEY, ContractStatusState,
    selectAllContractStatus,
    selectContractStatusFetched,
} from '../../reducers/mdqx/contract-status.reducer';
import {
    FACHBEREICH_KEY,
    FachbereichState,
    selectAllFachbereiche,
    selectFachbereicheFetched,
} from '../../reducers/mdqx/fachbereich.reducer';
import {
    CONTRACT_PARTICIPANT_KEY,
    ContractParticipantState, selectAllContractParticipants,
    selectContractParticipantsFetched,
} from '../../reducers/mdqx/contract-participant.reducer';
import {
    DIAGNOSESICHERHEIT_KEY, DiagnosesicherheitState,
    selectAllDiagnosesicherheiten,
    selectDiagnosesicherheitenFetched,
} from '../../reducers/mdqx/diagnosesicherheit.reducer';
import {
    selectAllTEGueltigkeiten,
    selectTEGueltigkeitenFetched,
    TEGUELTIGKEIT_KEY, TEGueltigkeitState,
} from '../../reducers/mdqx/te-gueltigkeit.reducer';
import {
    CUSTOMER_OPTIONS_KEY,
    CustomerOptionsState,
    selectAllCustomerOptions, selectCustomerOptionsFetched,
} from '../../reducers/mdqx/customer-options.reducer';
import {
    CUSTOMER2QUALIFICATION_KEY,
    Customer2QualificationState, selectAllCustomer2Qualifications, selectCustomer2QualificationsFetched,
} from '../../reducers/mdqx/customer2qualification.reducer';

export const selectMandateType = createFeatureSelector<State, MandateTypeState>(MANDATE_TYPE_KEY);

export const selectDoctor = createFeatureSelector<State, DoctorState>(DOCTOR_KEY);

export const selectPracticeType = createFeatureSelector<State, PracticeTypeState>(
    PRACTICE_TYPE_KEY,
);
export const selectCustomerOptions = createFeatureSelector<State, CustomerOptionsState>(
    CUSTOMER_OPTIONS_KEY,
);
export const selectContract = createFeatureSelector<State, ContractState>(CONTRACT_KEY);

export const selectContractOptions = createFeatureSelector<State, ContractOptionsState>(
    CONTRACT_OPTIONS_KEY,
);
export const selectContract2Plausibilitaet = createFeatureSelector<State,
    Contract2PlausibilitaetState>(CONTRACT2PLAUSIBILITAET_KEY);

export const selectPlausibilitaet = createFeatureSelector<State, PlausibilitaetState>(
    PLAUSIBILITAET_KEY,
);

export const selectContract2Diagnosesicherheit = createFeatureSelector<State,
    Contract2DiagnosesicherheitState>(CONTRACT2DIAGNOSESICHERHEIT_KEY);

export const selectCustomer2Qualification = createFeatureSelector<State,
    Customer2QualificationState>(CUSTOMER2QUALIFICATION_KEY);

export const selectContractGroupType = createFeatureSelector<State, ContractGroupTypeState>(
    CONTRACTGROUPTYPE_KEY,
);

export const selectContractStatus = createFeatureSelector<State, ContractStatusState>(
    CONTRACTSTATUS_KEY,
);

export const selectDiagnosesicherheit = createFeatureSelector<State, DiagnosesicherheitState>(
    DIAGNOSESICHERHEIT_KEY,
);

export const selectSpezifikation = createFeatureSelector<State, SpezifikationState>(
    SPEZIFIKATION_KEY,
);

export const selectSpezifikationsArt = createFeatureSelector<State, SpezifikationsArtState>(
    SPEZIFIKATIONSART_KEY,
);

export const selectTEGueltigkeit = createFeatureSelector<State, TEGueltigkeitState>(
    TEGUELTIGKEIT_KEY,
);

export const selectContract2Fachbereich = createFeatureSelector<State, Contract2FachbereichState>(
    CONTRACT2FACHBEREICH_KEY,
);

export const selectFachbereich = createFeatureSelector<State, FachbereichState>(FACHBEREICH_KEY);

export const selectContractParticipant = createFeatureSelector<State, ContractParticipantState>(
    CONTRACT_PARTICIPANT_KEY,
);

export const selectContractPartner = createFeatureSelector<State, ContractPartnerState>(
    CONTRACT_PARTNER_KEY,
);
export const getDoctors = createSelector(selectDoctor, selectAllDoctors);

export const getDoctorsById =  (props: { id: number }) => createSelector(getDoctors, (doctors) => props?.id && doctors.find(d => d.Id === props.id));

export const getDoctorsByCustomerId = createSelector(
    getDoctors,
    (doctors: ReturnType<typeof getDoctors>, customerId: number) =>
        doctors ? doctors.filter(d => d.CustomerIds.includes(customerId)) : null,
);

export const getDoctorsFetched = createSelector(selectDoctor, selectDoctorsFetched);
export const getPracticeTypes = createSelector(selectPracticeType, selectAllPracticeTypes);

export const getPracticeTypesFetched = createSelector(
    selectPracticeType,
    selectPracticeTypesFetched,
);
export const getCustomerOptions = createSelector(selectCustomerOptions, selectAllCustomerOptions);

export const getCustomerOptionsFetched = createSelector(
    selectCustomerOptions,
    selectCustomerOptionsFetched,
);
export const getContracts = createSelector(selectContract, selectAllContracts);

export const getContractsFetched = createSelector(selectContract, selectContractsFetched);

export const getContractOptions = createSelector(selectContractOptions, selectAllContractOptions);

export const getContractOptionsFetched = createSelector(
    selectContractOptions,
    selectContractOptionsFetched,
);

export const getContract2Plausibilitaeten = createSelector(
    selectContract2Plausibilitaet,
    selectAllContract2Plausibilitaeten,
);
export const getContract2PlausibilitaetenFetched = createSelector(
    selectContract2Plausibilitaet,
    selectContract2PlausibilitaetenFetched,
);

export const getPlausibilitaeten = createSelector(selectPlausibilitaet, selectAllPlausibilitaeten);

export const getPlausibilitaetenFetched = createSelector(
    selectPlausibilitaet,
    selectPlausibilitaetenFetched,
);

export const getContract2Diagnosesicherheiten = createSelector(
    selectContract2Diagnosesicherheit,
    selectAllContract2Diagnosesicherheiten,
);

export const getContract2DiagnosesicherheitenFetched = createSelector(
    selectContract2Diagnosesicherheit,
    selectContract2DiagnosesicherheitenFetched,
);

export const getCustomer2Qualifications = createSelector(
    selectCustomer2Qualification,
    selectAllCustomer2Qualifications,
);

export const getCustomer2QualificationsFetched = createSelector(
    selectCustomer2Qualification,
    selectCustomer2QualificationsFetched,
);

export const getContractGroupType = createSelector(
    selectContractGroupType,
    selectAllContractGroupType,
);

export const getContractGroupTypeFetched = createSelector(
    selectContractGroupType,
    selectContractGroupTypeFetched,
);

export const getContractStatus = createSelector(selectContractStatus, selectAllContractStatus);

export const getContractStatusFetched = createSelector(
    selectContractStatus,
    selectContractStatusFetched,
);

export const getDiagnosesicherheiten = createSelector(
    selectDiagnosesicherheit,
    selectAllDiagnosesicherheiten,
);

export const getDiagnosesicherheitenFetched = createSelector(
    selectDiagnosesicherheit,
    selectDiagnosesicherheitenFetched,
);

export const getSpezifikationen = createSelector(selectSpezifikation, selectAllSpezifikationen);

export const getSpezifikationenFetched = createSelector(
    selectSpezifikation,
    selectSpezifikationenFetched,
);

export const getSpezifikationsArt = createSelector(
    selectSpezifikationsArt,
    selectAllSpezifikationsArten,
);

export const getSpezifikationsArtFetched = createSelector(
    selectSpezifikationsArt,
    selectSpezifikationsArtenFetched,
);

export const getTEGueltigkeiten = createSelector(selectTEGueltigkeit, selectAllTEGueltigkeiten);

export const getTEGueltigkeitenFetched = createSelector(
    selectTEGueltigkeit,
    selectTEGueltigkeitenFetched,
);

export const getContract2Fachbereiche = createSelector(
    selectContract2Fachbereich,
    selectAllContract2Fachbereiche,
);

export const getContract2FachbereicheFetched = createSelector(
    selectContract2Fachbereich,
    selectContract2FachbereicheFetched,
);

export const getFachbereiche = createSelector(selectFachbereich, selectAllFachbereiche);

export const getFachbereicheFetched = createSelector(selectFachbereich, selectFachbereicheFetched);

export const getContractParticipants = createSelector(
    selectContractParticipant,
    selectAllContractParticipants,
);

export const getContractParticipantsByCustomerId = createSelector(
    getContractParticipants,
    (participants: ReturnType<typeof getContractParticipants>, customerId: number) =>
        participants && participants.filter(p => p.CustomerId === customerId)
);

export const getContractParticipantsFetched = createSelector(
    selectContractParticipant,
    selectContractParticipantsFetched,
);

export const getContractsByCustomerId = createSelector(
    getContractParticipantsByCustomerId,
    getContracts,
    (participants: ReturnType<typeof getContractParticipantsByCustomerId>, contracts: ReturnType<typeof getContracts>, customerId: number) => {
        return participants && contracts && contracts.filter(c => participants.find(p => p.ContractId === c.Id) !== undefined);
    }
);

export const getContractPartners = createSelector(selectContractPartner, selectAllContractPartners);

export const getContractPartnersFetched = createSelector(
    selectContractPartner,
    selectContractPartnersFetched,
);
// Get by Id
export const getContractById =  (props: { id: number }) => createSelector(getContracts, (contracts) => props?.id && contracts.find(c => c.Id === props.id));

// Get by ContractId

export const getContractOptionsByContractId = createSelector(
    getContractOptions,
    (contracts: ReturnType<typeof getContractOptions>, id: number) =>
        contracts && contracts.find(c => c.ContractId === id),
);
export const getCustomersByContractId = createSelector(
    getCustomers,
    getContractParticipants,
    (
        customers: ReturnType<typeof getCustomers>,
        contractParticipants: ReturnType<typeof getContractParticipants>,
        id: number,
    ) => {
        const cps = contractParticipants.filter(cp => cp.ContractId === id);
        return customers && customers.filter(c => !!cps.find(cp => cp.CustomerId === c.Id));
    },
);
